import React, { JSX } from 'react';
/* @ts-ignore */
import everfiLogo from '../../images/everfi_logo.svg';
/* @ts-ignore */
import everfiLogoFIT from '../../images/everfi_logo_FIT.svg';
import { AttentionGrabber } from '../attention-grabber';
import { formatClassName } from '../../utils';

interface Props {
  customLeft: string;
  isDashiFi: boolean;
  isEverfiAdmin: boolean;
  isImpersonating: boolean;
  isMobile: boolean;
  isNextAdmin: boolean;
  isUnauthenticated: boolean;
  logoOverrideHyperlink: string;
  logoOverrideUrl: string;
  organization?: {
    demo?: boolean;
    logo_url?: string;
    name?: string;
  };
}

const TopLeftMenu: React.FC<Props> = ({
  customLeft,
  isDashiFi,
  isEverfiAdmin,
  isImpersonating,
  isMobile,
  isNextAdmin,
  isUnauthenticated,
  logoOverrideHyperlink,
  logoOverrideUrl,
  organization,
}) => {
  const nonCustomHeaderLogo = (): JSX.Element => {
    if (logoOverrideUrl) {
      // this can be anything sent in. i. e. the branding set at the program level in next
      const img = <img alt={`${organization?.name}'s logo`} src={logoOverrideUrl} />;
      return logoOverrideHyperlink ? <a href={logoOverrideHyperlink}>{img}</a> : img;
    } else if (organization?.logo_url) {
      // this one comes from the uploaded image at the account level branding. It has no hyperlink feature
      return <img alt={`${organization.name}'s logo`} src={organization.logo_url} />;
    }
    return <img src={everfiLogo} alt="EverFi logo" />;
  };

  const demoOrgAttentionGrabber = () => {
    if (!organization?.demo || isMobile) return null;

    const serverSide = typeof window === 'undefined';
    if (!serverSide) return <AttentionGrabber type="info" label="Demo Account" className="m-l-20 f-14" />;

    // NXT-6333: for now, we cannot render chakraUI in SSR components
    return (
      <span
        className="attention-grabber attention-grabber-info m-l-20 f-14"
        style={{
          height: 24,
          fontWeight: 500,
          display: 'inline-flex',
          alignItems: 'center',
          border: '1px solid #74b2ec',
          borderRadius: 2,
          padding: '3px 7px',
          backgroundColor: '#e3effb',
        }}
      >
        <span className="attention-grabber-label" style={{ color: '#18519f' }}>
          Demo Account
        </span>
      </span>
    );
  };

  if (isEverfiAdmin && !isUnauthenticated && !isNextAdmin) {
    const adminHeaderClasses = formatClassName(['admin-header-logo', { impersonating: isImpersonating }]);
    return (
      <div className={adminHeaderClasses}>
        <div className="wrench-logo">
          <img src={everfiLogoFIT} alt="EverFi logo" />
        </div>
        <div className="wrench-label">Foundry Internal Tools</div>
      </div>
    );
  } else if (customLeft) {
    return <div className="navbar-brand navbar-logo float-none" dangerouslySetInnerHTML={{ __html: customLeft }} />;
  } else {
    return (
      <>
        <div className="header-item header-logo">
          {nonCustomHeaderLogo()}
          {!isDashiFi && (
            <button
              id="skipLink"
              className="sr-only sr-only-focusable"
              /* @ts-ignore */
              tabIndex="0"
              aria-label="Skip to main content"
              href="#"
            >
              Skip to main content
            </button>
          )}
        </div>
        {demoOrgAttentionGrabber()}
      </>
    );
  }
};

TopLeftMenu.displayName = 'TopLeftMenu';

export default TopLeftMenu;
